
import { getAPI , postAPI } from "../../api/api"
import { REACT_APP_CUSTOMER , REACT_APP_JOB , REACT_APP_RECRUITER } from "../../utils/common"


export async function getAllCompanies(pageNumber: number, pageSize: number, searchValue: string, data?: any,sort?:any) {

  let sortfilter={
 
};
if(sort)
{
  if(sort.length!=0)
  {
     sortfilter={
          
            sortBy:sort[0].field,
            sortOrder:sort[0].dir
        
    };
  }
}
if( Object.keys(sortfilter).length===0)

{
var merge=data;
}
else
{
  var merge={...data,sort:sortfilter};
}
    const Details = postAPI( REACT_APP_CUSTOMER + `/all-customer-details?page=${pageNumber ? pageNumber : 1}&size=${pageSize ? pageSize : 1}${searchValue ? `&companyName=${searchValue}` : ''}`,merge ? merge : {})
    return Details
}

export async function getPendingCompanies(pageNumber: number, pageSize: number, searchValue: string, data?: any,sort?:any){

  let sortfilter={
    
};
if(sort)
{
  if(sort.length!=0)
  {
     sortfilter={
          
            sortBy:sort[0].field,
            sortOrder:sort[0].dir
        
    };
  }
}
if( Object.keys(sortfilter).length===0)

{
var merge=data;
}
else
{
  var merge={...data,sort:sortfilter};
}

  const Details = postAPI( REACT_APP_CUSTOMER + `/pending-customer-details?page=${pageNumber ? pageNumber : 1}&size=${pageSize ? pageSize : 1}${searchValue ? `&companyName=${searchValue}` : ''}` ,merge)
  return Details
}
export async function getDraftCompanies(pageNumber: number, pageSize: number, searchValue: string, data?: any,sort?:any){
  let sortfilter={
  };
if(sort)
{
  if(sort.length!=0)
  {
     sortfilter={
          
            sortBy:sort[0].field,
            sortOrder:sort[0].dir
        
    };
  }
}
if( Object.keys(sortfilter).length===0)

{
var merge=data;
}
else
{
  var merge={...data,sort:sortfilter};
}

  const Details = postAPI( REACT_APP_CUSTOMER + `/draft-companies?page=${pageNumber ? pageNumber : 1}&size=${pageSize ? pageSize : 1}${searchValue ? `&companyName=${searchValue}` : ''}` ,merge)
  return Details
}
export async function approveOrRejectCustomer(body: any) {
  const Details = postAPI( REACT_APP_CUSTOMER + '/approve-reject', body)
  return Details
}

export async function updateSourcedBy(body: any) {
  const Details = postAPI( REACT_APP_JOB + '/updateSourcedByAndBehalfOf', body)
  return Details
}

export async function userLevelApproveRejectCustomer(body: any) {
  const Details = postAPI(REACT_APP_CUSTOMER +  '/approve-reject-user', body)
  return Details
}

export async function getAllocatedto() {
  const Details = getAPI( REACT_APP_RECRUITER + "/list")
  return Details
}

export async function customerAllocation(body: any) {
  const Details = postAPI(REACT_APP_CUSTOMER +  '/customer-allocation', body)
  return Details
}

export async function blackListProvider(body: any) {
  const Details = postAPI(REACT_APP_CUSTOMER + '/blacklist-provider', body)
  return Details
}